(function() {
  function getCountry() {
    var code = document.body.dataset.shopifyCountry;
    return code ? code.toUpperCase() : null;
  }

  function applyGeorgiaCurrency() {
    if (getCountry() !== 'GE') return;

    var currencySelect =
      document.querySelector('#CurrencySelector') ||
      document.querySelector('.currency-picker select');

    if (!currencySelect) return;

    var gelOption = Array.from(currencySelect.options).find(function(option) {
      return /GEL|Lari/i.test(option.value + ' ' + option.text);
    });

    if (!gelOption) {
      gelOption = new Option('GEL', 'GEL');
      currencySelect.add(gelOption);
    }

    currencySelect.value = gelOption.value;
    currencySelect.dispatchEvent(new Event('change', { bubbles: true }));
    currencySelect.dispatchEvent(new Event('currency:change', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGeorgiaCurrency);
  } else {
    applyGeorgiaCurrency();
  }
})();
